<!-- Hidden button for the add new trigger -->
<div class="input-group-append" style="display: none;">
  <button type="submit" class="btn btn-default" id="btn" data-toggle="modal" data-target="#formModal">
    <i class="fas fa-create"></i> Add new property
  </button>
</div>


<div class="modal fade" id="formModal" tabindex="-1" role="dialog" aria-labelledby="formModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 80%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="formModalTitle">Manage Property</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="create_close_btn">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="pf" (ngSubmit)="onSubmit()" #documentEditForm="ngForm">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="plot_number">Property ID</label>
              <input type="text" class="form-control" id="pid" formControlName="pid" >
            </div>
            <div class="form-group col-md-6">
              <label for="property_type">Type</label>
              <select class="form-control custom-select" name="type" id="type" formControlName="type">
                <option value="plot" *ngIf="project.type ==='residential'">Plot</option>
                <option value="builderFloor" *ngIf="project.type ==='residential'">Builder Floor</option>
                <option value="commercial" *ngIf="project.type ==='commercial'">Commercial Floor</option>
              </select>
            </div>
          </div>

          <div class="form-row" *ngIf="pf.get('type').value === 'plot'">
            <div class="form-group col-md-3">
              <label for="length">Length </label>
              <input type="text" class="form-control" id="length" formControlName="length">
            </div>
            <div class="form-group col-md-3">
              <label for="width">Width </label>
              <input type="text" class="form-control" id="width" formControlName="width">
            </div>
            <div class="form-group col-md-6">
              <label for="property_type">Area</label>
              <input type="text" class="form-control" id="carpet_area" formControlName="carpet_area" >
            </div>
          </div>

          <div class="form-row" *ngIf="pf.get('type').value !== 'plot'">
            <div class="form-group col-md-6">
              <label for="property_type">Carpet Area</label>
              <input type="text" class="form-control" id="carpet_area" formControlName="carpet_area" >
            </div>
            <div class="form-group col-md-6">
              <label for="property_type">Super Area</label>
              <input type="text" class="form-control" id="super_area" formControlName="super_area" >
            </div>
          </div>

          <div class="form-row" >
            <div class="form-group col-md-6">
              <label for="base_price">BSP</label>
              <input type="text" class="form-control" id="base_price" formControlName="base_price" >
            </div>
            <div class="form-group col-md-3">
              <label for="edc">IFMS</label>
              <input type="text" class="form-control" id="edc" formControlName="edc" >
            </div>
            <div class="form-group col-md-3">
              <label for="gst">GST (%)</label>
              <input type="text" class="form-control" id="gst" formControlName="gst" disabled>
            </div>
          </div>

          <div class="form-row" *ngIf="pf.get('type').value !== 'plot'">
            <div class="form-group col-md-6">
              <label for="inventory">Floor</label>
              <input type="text" class="form-control" id="inventory" formControlName="inventory" >
            </div>
            <div class="form-group col-md-6">
              <label for="inventory">Floor Price</label>
              <input type="text" class="form-control" id="inventory_price" formControlName="inventory_price" >
            </div>
          </div>

          <div class="form-row" >
            <div class="form-group col-md-6">
              <label for="">PLC</label>
              <br>
              <div class="form-check form-check-inline" *ngFor="let plc of dropdownList; let i = index">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox{{i}}" (click)="addPlc(plc)" [checked]="plcCheckBox(plc,i)">
                <label class="form-check-label" for="inlineCheckbox{{i}}">{{plc.plc_name}}</label>
              </div>
            </div>
            <div class="form-group col-md-6" *ngIf="editFlag">
              <label for="status">Status Hold/Sold</label>
              <select id="status" class="form-control custom-select" formControlName="status">
                <option value="available">Available</option>
                <option value="hold">Hold</option>
                <option value="sold">Sold</option>
              </select>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="documentEditForm.ngSubmit.emit()">
          <span *ngIf="!editFlag">Add</span>
          <span *ngIf="editFlag">Save</span>
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Button trigger for Details modal -->
<button style="display: none;" type="button" id="info-btn" class="btn btn-primary" data-toggle="modal"
  data-target="#detailsModal">
  create new property HIDEN
</button>

<!-- Details Modal -->
<div class="modal fade" id="detailsModal" tabindex="-1" role="dialog" aria-labelledby="detailsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 40%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="detailsModalTitle" *ngIf="plotDetails">{{plotDetails.pid}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table" *ngIf="plotDetails">
          <tbody>
            <tr>
              <th scope="row">Carpet Area</th>
              <td>{{plotDetails.carpet_area}}</td>
            </tr>
            <tr>
              <th scope="row">Floor</th>
              <td>{{plotDetails.inventory}}</td>
            </tr>
            <tr>
              <th scope="row">Floor Price</th>
              <td>{{plotDetails.inventory_price}}
              </td>
            </tr>
            <tr>
              <th scope="row">Status</th>
              <td>{{plotDetails.status}}</td>
            </tr>
            <tr>
              <th scope="row">BSP</th>
              <td>{{plotDetails.project.base_price}}</td>
            </tr>
            <tr>
              <th scope="row">PLC</th>
              <td><span *ngFor="let plc of plotDetails.plc">{{plc.plc_name}},</span></td>
            </tr>
            <tr>
              <th scope="row">IFMS</th>
              <td>{{plotDetails.edc}}</td>
            </tr>
            <tr>
              <th scope="row">GST</th>
              <td>{{plotDetails.project.gst}}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<!-- table view  -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="input-group input-group-sm" style="width: 250px;">

            <div class="input-group-append"
              *ngIf="currentUser.role === 'admin' || currentUser.role === 'manager' ">
              <button type="submit" class="btn btn-default" id="btn" (click)="add();">
                <i class="fas fa-create"></i> Add new property
              </button>
            </div>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default" (click)="export()">Export
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 300px;">
            <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right"
              placeholder="Search">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>

            <select type="text" name="table_search" [(ngModel)]="sortby" class="form-control float-right">
              <option value="type">Type</option>
              <!-- <option value="area">Area</option> -->
              <option value="status">Status</option>
            </select>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-sort"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
      <div class="card-body table-responsive p-0" style="height: 410px;">
        <table class="table table-head-fixed text-nowrap" #assetsTable>
          <thead>
            <tr>
              <th>Property ID</th>
              <th>Type</th>
              <th>Area</th>
              <th>Status</th>
              <th>Sales Date</th>
              <th>Floor</th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="!isloading">
            <tr *ngFor="let plt of pltData | filter: searchString: 'status' | sort: [ sortby,'pid'] ">
              <td>{{ plt.pid}}</td>
              <td>{{ plt.type}}</td>
              <td>{{ plt.carpet_area }}</td>
              <td>{{ plt.status }}</td>
              <td *ngIf="plt.customer[0]">{{plt.customer[0].createdAt| date:'longDate'}}</td>
              <td *ngIf="!plt.customer[0]">NA</td>
              <td *ngIf="plt.type ==='plot'">NA</td>
              <td *ngIf="plt.type !=='plot'">{{ plt.inventory }}</td>
              <td>
                <a class="btn" (click)="info(plt)"><i class="fas fa-info"></i></a>
                <span *ngIf="currentUser.role === 'admin' || currentUser.role === 'manager' ">
                  <a class="btn" (click)="edit(plt)"><i class="fas fa-edit"></i></a>
                  <a class="btn" (click)="delete(plt)"><i class="fas fa-trash"></i></a>
                </span>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="isloading">
            <td class="text-center" colspan="6">loading ...</td>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
